( function () {
    'use strict';
    e.ecom.productgrid = {};
    e.ecom.productgrid.init = function () {
        if ( jQuery( '.e-ecom-grid' ).length === 1 && jQuery( '.e-productdetails' ).length === 0 ) {
            e.ecom.productlist.sort.init();
            e.ecom.productlist.filter.init();
            e.ecom.filters.init();
        }
    };
    e.ecom.filters = {
        isDefault: function () {
            var jProductFilters = jQuery( '.js-e-productlist-filters' );
            jProductFilters.find( 'input[type="checkbox"]' ).on( 'change', function () {
                if ( jQuery( this ).attr( 'name' ) === 'ItemGroup' ) {
                    jProductFilters.find( 'input[name="IsDefault"]' ).val( true );
                }
                else {
                    jProductFilters.find( 'input[name="IsDefault"]' ).val( '' );
                }
            } );
        },
        toggleIcon: function () {
            jQuery( '.js-e-productlist-filters' ).find( '.accordion-toggle' ).on( 'click', function () {
                if ( jQuery( this ).find( 'i.toggle-icon' ).hasClass( 'icon-angle-down' ) ) {
                    jQuery( this ).find( 'i.toggle-icon' ).removeClass( 'icon-angle-down' ).addClass( 'icon-angle-up' );
                }
                else {
                    jQuery( this ).find( 'i.toggle-icon' ).removeClass( 'icon-angle-up' ).addClass( 'icon-angle-down' );
                }
                //jQuery('.toggle-icon.icon-angle-up').toggleClass('icon-angle-up icon-angle-down');
                //jQuery(this).find('.toggle-icon').toggleClass('icon-angle-up icon-angle-down');
            } );
        },
        init: function () {
            this.isDefault();
            this.toggleIcon();
        }
    };
}() );
